<template>
  <div class="cust-shadow bg-white rounded-12px pt-4 relative">
    <div class="flex justify-between items-center px-5">
      <div class="">
        <h2 class="text-black fsize14 flex items-center font-semibold">
          Project Resources
          <!-- <feather-icon
            icon="InfoIcon"
            class="ml-1 text-grey flex"
            svgClasses="w-5 h-5"
          /> -->
        </h2>
      </div>
      <!-- 
      <div
  
        class="flex justify-center bg-light-primary cursor-pointer rounded-full items-center w-10 h-10"
      >
        <feather-icon
          icon="ChevronRightIcon"
          svgClasses="w-5 h-5"
          class="text-primary font-semibold flex"
        />
      </div> -->
    </div>

    <div class="mt-8 heigh-dd px-5 pb-4">
      <div class="mb-0">
        <div
          class="flex mb-5 items-center"
          v-for="(item, index) in cards"
          :key="'item-' + index"
        >
          <img
            :src="showImage(item.addOnId.images)"
            class="object-contain w-12 h-12 bg-ec rounded-full"
          />
          <div class="pl-4">
            <h2 class="text-black fsize14 my-0 font-semibold">
              {{ item.addOnId.name }}
            </h2>
            <p class="text-gray pt-1 mb-0 fsize12 font-semibold">
              {{
                item.addOnId.name == "Storage"
                  ? Number(item.quantity / 1024 / 1024).toFixed(2)
                  : item.quantity.toFixed(2)
              }}
              {{ item.addOnId.unit }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <vs-button
      color="primary"
      @click="handleClick('Add-ons')"
      class="w-full rounded-tl-none py-3 rounded-tr-none"
    >
      Manage Add-Ons
    </vs-button>
    <!-- <div
      class="bg-primary bottom-0 left-0 absolute w-full text-center rounded-b-12px flex items-center justify-center p-4"
    >
      <h2 class="text-white fsize14 pl-2 font-medium mb-0">Manage Add-Ons</h2>
    </div> -->
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      cards: [
        // {
        //   id: "01",
        //   image:
        //     "https://nimbuscluster.blob.core.windows.net/server01/brained/image/m1.png",
        //   title: "WhatsApp Credits",
        //   num: "1420000",
        // },
        // {
        //   id: "02",
        //   image:
        //     "https://nimbuscluster.blob.core.windows.net/server01/brained/image/m2.png",
        //   title: "SMS Credits",
        //   num: "1420000",
        // },
        // {
        //   id: "03",
        //   image:
        //     "https://nimbuscluster.blob.core.windows.net/server01/brained/image/m3.png",
        //   title: "Email Credits",
        //   num: "1420000",
        // },
        // {
        //   id: "04",
        //   image:
        //     "https://nimbuscluster.blob.core.windows.net/server01/brained/image/m4.png",
        //   title: "Push Notification",
        //   num: "1420000",
        // },
        // {
        //   id: "04",
        //   image:
        //     "https://nimbuscluster.blob.core.windows.net/server01/brained/image/m4.png",
        //   title: "Push Notification",
        //   num: "1420000",
        // },
      ],
    };
  },
  methods: {
    async getAddOnsUsageDetails() {
      let payload = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
      };
      let data = await this.$store.dispatch(
        "projectFile/getAddOnsUsageDetails",
        payload
      );
      console.log(data.data, "addOns");
      this.cards = data.data;
    },
    showImage(value) {
      let default_image = require("@/assets/images/card1.png");
      return value
        ? `${process.env.VUE_APP_IMAGE_URL}/${value}`
        : default_image;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
  computed: {
    ...mapState("user", ["selectedProject"]),
    ...mapState("projectFile", ["selectedProjectDetails"]),
  },
  async mounted() {
    await this.getAddOnsUsageDetails();
  },
};
</script>
